module.exports = __webpack_public_path__ + "static/4-key-tangible-business-benefits-of-embracing-remote-work-b7733a6c9215bfe533b7bd486fc5c0af.png";